import React from "react"
import { Badge, BadgeVariant } from "../../shared/components/Badge"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
// Profile status enums for provider/practice
export enum ProfileStatusEnum {
  PENDING = "pending",
  PENDING_ACTIVATION = "pending-activation",
  ACTIVE = "active",
  SUSPENDED = "suspended",
  DEACTIVATED = "deactivated",
  ORPHANED = "orphaned",
}

interface ProfileStatusBadgeProps {
  status: ProfileStatusEnum
  className?: string
}

export const ProfileStatusBadge: React.FC<ProfileStatusBadgeProps> = ({
  status,
}) => {
  const { cms: cmsContent } = useCMSReady(["providerStatusAdjectives"])
  const statusAdjectives = cmsContent.providerStatusAdjectives

  // Color mapping per Figma
  const colorMap: Record<ProfileStatusEnum, BadgeVariant> = {
    [ProfileStatusEnum.PENDING]: "purple",
    [ProfileStatusEnum.PENDING_ACTIVATION]: "purple",
    [ProfileStatusEnum.ACTIVE]: "green",
    [ProfileStatusEnum.SUSPENDED]: "red",
    [ProfileStatusEnum.DEACTIVATED]: "red",
    [ProfileStatusEnum.ORPHANED]: "orphaned",
  }

  const badgeText = statusAdjectives?.[status]
  const badgeColor = colorMap[status]
  if (!badgeText) return null

  return <Badge text={badgeText} color={badgeColor} />
}
